import React from 'react';
import { Box, Typography } from '@mui/material';

import Description from 'components/CareSummary/Description';
import Empty from 'components/CareSummary/Empty';
import Title from 'components/CareSummary/Title';
import { Container } from 'shared-components/Container';
import { useGetProfileParticipantTasksQuery, useGetProfileParticipantTaskQuery } from 'store/api/pkd/endpoints/participantTask';
import { useGetPersonAndAttributes } from 'hooks/useGetPersonAndAttributes';
import { TaskTitles } from 'utils/enum';
import { ChartTextSkeleton } from '../ChartSkeleton';
import { getDietConsiderations } from './utils';

const DietConsiderations = () => {
  const { isPersonLoading, isPersonAttributesFetching, person, personId, personAccountProfileId } =
    useGetPersonAndAttributes();

  const { participantTask, isParticipantTaskLoading } =
    useGetProfileParticipantTasksQuery(
      { personAccountProfileId },
      { skip             : !personAccountProfileId ,
        selectFromResult : ({ data = [], isFetching }) => ({
          participantTask          : data,
          isParticipantTaskLoading : isFetching,
        }),
      }
    );
    
  const coreQuestionnaireTaskId = participantTask?.find(item => item.taskTitle === TaskTitles.coreQuestionnaire)?.id;
    
  const { data:coreQuestionnaire, isLoading:isCoreQuestionnaireLoading } =
    useGetProfileParticipantTaskQuery(
      { personAccountProfileId, participantTaskId: coreQuestionnaireTaskId },
      { skip: !coreQuestionnaireTaskId }
    );
  const coreQuestionnaireData = coreQuestionnaire;
  
  const dietConsiderationTaskId = participantTask?.find(item => item.taskTitle === TaskTitles.dietLifestyle)?.id;

  const { data:dietConsiderations, isLoading:isDietConsiderationsLoading } =
    useGetProfileParticipantTaskQuery(
      { personAccountProfileId, participantTaskId: dietConsiderationTaskId },
      { skip: !dietConsiderationTaskId }
    );

  const diets = getDietConsiderations(dietConsiderations);
  const isLoading =
    isPersonLoading ||
    isDietConsiderationsLoading ||
    isParticipantTaskLoading ||
    isCoreQuestionnaireLoading;

  const content = isLoading
    ? (
      <ChartTextSkeleton />
    )
    : diets.length > 0
      ? (
        <>
          <Box
            m='20px 0px'>
            {diets.map((diet) => (
              <Typography
                key={diet.key} variant='pl1' mb={1}>
                <span
                  data-testid={`diet-item-${diet.key}`}>{diet.key}:</span>
                <span
                  style={{ marginLeft: '10px' }}>
                  <b>{diet.value}</b>
                </span>
                <br />
              </Typography>
            ))}
          </Box>
        </>
      )
      : (
        <Empty
          description='Fill out the Diet & Lifestyle module'
          to={`/questionnaire/${dietConsiderations?.participantTaskId}`}
          buttonText='Fill out the Diet & Lifestyle module'
          hideAction={
            !coreQuestionnaireData?.taskEntry ||
        (Boolean(coreQuestionnaireData?.taskEntry) &&
          dietConsiderations?.length === 0)
          }
        />
      );

  return (
    <Container>
      <Title>Diet considerations</Title>
      <Description>
        There is no diet proven to treat PKD. Clinicians may recommend limiting
        sodium or eating foods lower in phosphorus or potassium as kidney
        function declines.
      </Description>
      {content}
    </Container>
  );
};

export default DietConsiderations;
